import i18next from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LANGUAGE, resources } from './locales'

// Namespaces loaded on demand rather than bundled with the app. Each language's
// chunk is fetched the first time a component asks for the namespace (currently
// only the public booking page), so these strings never ship to users who don't
// open that page. `partialBundledLanguages` lets i18next keep using the bundled
// `resources` for every other namespace while resolving these through the loader.
const lazyResources = import.meta.glob<Record<string, unknown>>(
	'./locales/*/booking.json',
	{ import: 'default' },
)

void i18next
	.use(resourcesToBackend((language: string, namespace: string) => {
		const loader = lazyResources[`./locales/${language}/${namespace}.json`]
		if (!loader) {
			return Promise.reject(new Error(`No lazy i18n resource for ${language}/${namespace}`))
		}
		return loader()
	}))
	.use(initReactI18next)
	.init({
		lng: DEFAULT_LANGUAGE,
		fallbackLng: DEFAULT_LANGUAGE,
		resources,
		partialBundledLanguages: true,
		ns: ['auth', 'common', 'analytics', 'start', 'editor'],
		defaultNS: 'common',
		interpolation: { escapeValue: false },
	})

export default i18next
